export default __webpack_public_path__ + "static/media/cpv_09_energy-source.5c96d64a.svg";